var IncrementalDOM = require('incremental-dom')
var patch = IncrementalDOM.patch
var elementOpen = IncrementalDOM.elementOpen
var elementClose = IncrementalDOM.elementClose
var skip = IncrementalDOM.skip
var currentElement = IncrementalDOM.currentElement
var text = IncrementalDOM.text

var hoisted1 = ["class", "form-group"]
var hoisted2 = ["class", "checkbox-inline"]
var hoisted3 = ["type", "checkbox"]
var hoisted4 = ["class", "checkbox-inline"]
var hoisted5 = ["type", "checkbox"]
var hoisted6 = ["class", "checkbox-inline"]
var hoisted7 = ["type", "checkbox"]
var hoisted8 = ["class", "form-group"]
var hoisted9 = ["for", "defaultValue"]
var hoisted10 = ["type", "text", "id", "defaultValue", "class", "form-control input-sm", "placeholder", "Default value"]
var __target

module.exports = function description (model) {
elementOpen("div", "81a773dd-b5af-4fad-b217-dec02fdd06f1", hoisted1)
  elementOpen("div")
    elementOpen("label", "615bb0b4-f124-44b1-903c-2f4f077382ae", hoisted2)
      elementOpen("input", "f0d70aef-8951-4de8-a69f-260fae6f8835", hoisted3, "checked", model.required, "onchange", function ($event) {
        var $element = this;
      model.required = this.checked})
      elementClose("input")
      text(" Required \
          ")
    elementClose("label")
    elementOpen("label", "f10c9155-d982-4636-9db7-595bda40589b", hoisted4)
      elementOpen("input", "27960ff6-1922-4395-ad81-9d41a0cb09a8", hoisted5, "checked", model.unique, "onchange", function ($event) {
        var $element = this;
      model.unique = this.checked})
      elementClose("input")
      text(" Unique \
          ")
    elementClose("label")
    elementOpen("label", "97f3cd04-6029-4b1c-b494-65c8d4c792eb", hoisted6)
      elementOpen("input", "e3000520-b80a-49b8-bc37-a80633ccaa4e", hoisted7, "checked", model.index, "onchange", function ($event) {
        var $element = this;
      model.index = this.checked})
      elementClose("input")
      text(" Index \
          ")
    elementClose("label")
  elementClose("div")
elementClose("div")
elementOpen("div", "5a1d68d7-6a32-454d-ab6e-3345b1a3e522", hoisted8)
  elementOpen("label", "7d3fe730-6e2e-4bfd-a9bb-f2bc60062ea1", hoisted9)
    text("Default value")
  elementClose("label")
  elementOpen("input", "546336df-b66a-4ee5-8b9f-613e74a390ba", hoisted10, "value", model.defaultValue, "onchange", function ($event) {
    var $element = this;
  model.defaultValue = this.value})
  elementClose("input")
elementClose("div")
}
